export const companiesCompanyIdMobileAppLinkingConfigs = "/companies/:company_id/mobile_app_linking_configs";
